export const appName = "OpenIslands";

export const gitConfig = {
  user: "lukaisailovic",
  repo: "openislands",
  branch: "main",
};
